module.exports = __webpack_public_path__ + "img/KIDIWI_services-candy.svg";